// extracted by mini-css-extract-plugin
export var banner = "_le-0";
export var settingRow = "_le-2";
export var titleIcon = "_le-1";